/**
 @ngdoc controller
 @name BulkEditFieldCtrl

 @description
 This controller is used to bulk edit rows

 */
(function() {
    'use strict';
    var BulkEditFieldCtrl = function ($scope, $compile, $uibModalInstance, passedModel, ajaxCall, keyValueObjectService) {
        $scope.MODAL_DEBUG = false;
        $scope.useTestData = false;
        $scope.bulkEdit = passedModel;
        $scope.validateDataUrl;
        $scope.modalState = 'PAUSED';
        $scope.modifyTypeOptionList;
        $scope.rowIdSet;
        $scope.colKey;

        var log = function(identifier,data){
            if($scope.MODAL_DEBUG) console.log(identifier,data);
        };
        log('BulkEditFieldCtrl',[$scope, $compile, $uibModalInstance, passedModel]);

      /**
       * Remove field changes to source data
       *
       */
      var applyChangeToSourceData = function(){
        if(!isEmpty($scope.bulkEdit.editableField) || $scope.bulkEdit.removeData) {
          $scope.modalState = 'PROCESSING';
          setColKeyAndRowIdSet();
          validateRequestedDataChange();
        }
      };

        /**
         * Set up which Column the user is editing and what row Ids they are editing based upon the Editing All flag.
         */
        var setColKeyAndRowIdSet = function(){
            var selected = $scope.bulkEdit.user.selected;
            $scope.colKey = selected.colKey;
            if (selected.editingAll) {
                $scope.rowIdSet = $scope.bulkEdit.sourceData.headerLabels[$scope.colKey].editableRowIdSet;
            } else {
                $scope.rowIdSet = selected.rowIdSet;
            }
        };

        var recursiveValidateRequestedDataChange = function(requestedDataChangeList, idx){
            log('recursiveValidateRequestedDataChange()',idx);
            if( idx < requestedDataChangeList.length ) {
                var rowIdSet = requestedDataChangeList[idx].rowIdSet;
                delete requestedDataChangeList[idx].rowIdSet; //reducing dataSize
                var postData = requestedDataChangeList[idx];
                ajaxCall.getData($scope.validateDataUrl, postData).then(function (response) {
                    log('response.data', response.data);
                    loopData(rowIdSet, commitResponseData, response.data);
                    log('$scope.bulkEdit', $scope.bulkEdit);
                    idx++;
                    recursiveValidateRequestedDataChange(requestedDataChangeList,idx);
                }, function (response) {
                    console.log('AJAX Fail:', response.data);
                    $scope.modalState = 'FAILED';
                    $scope.ajaxFailResponse = response.status + ' ' + response.statusText;
                });
            } else {
                $scope.modalState = 'COMPLETED';
                $uibModalInstance.close($scope.bulkEdit);
            }
        };

        var validateRequestedDataChange = function(){
            log('validateRequestedDataChange()','AJAX time!');
            var requestedDataChange = getRequestedDataChange();
            if($scope.useTestData==false) {
                recursiveValidateRequestedDataChange(requestedDataChange,0);
            } else {
                loopData( $scope.rowIdSet, mockDataChange, null );
                $scope.modalState = 'COMPLETED';
                $uibModalInstance.close($scope.bulkEdit);
            }
        };
        /**
         * Looper Function -
         * @param row
         * @param cell
         * @param data
         */
        var mockDataChange = function(row, cell, data){
            if($scope.colKey=='payRate' && $scope.bulkEdit.modifyType && $scope.bulkEdit.modifyType.value == 'PERCENTAGE' ){
                cell.value = percentageChange(cell.value, cell.fractionDigits, $scope.bulkEdit.editableField);
            } else {
                cell.value = $scope.bulkEdit.editableField;
            }
        };

        /**
         * Prepare data for AJAX call - Now done in batches...
         * @returns [{{colKey: null|*, newFieldValue: string, modifyType: string, removeDate: Boolean rowList: Array}}]
         */
        var getRequestedDataChange = function(){
            var MAX_ROW_SIZE = 400;
            var beRef = $scope.bulkEdit;
            var rowIdSetList = keyValueObjectService.splitKeys( $scope.rowIdSet, MAX_ROW_SIZE, true );
            var requestedDataChange;
            var requestedDataChangeList = [];
            for (var idx=0, l = rowIdSetList.length; idx < l; idx++) {
                requestedDataChange = {
                    colKey: $scope.colKey,
                    newFieldValue: (beRef.removeData == false) ? beRef.editableField : null,
                    modifyType: beRef.modifyType ? beRef.modifyType.value : null,
                    removeSelected : beRef.removeData ? beRef.removeData : false,
                    rowList: [],
                    rowIdSet: rowIdSetList[idx]
                };

                loopData( rowIdSetList[idx] , pushRowIntoRequestedDataChange, requestedDataChange);

                requestedDataChangeList.push(requestedDataChange);
            }

            log('getRequestedDataChange()',requestedDataChangeList);
            return requestedDataChangeList;
        };

        var pushRowIntoRequestedDataChange = function(row, cell, requestedDataChange){
            if(cell.value !== requestedDataChange.newFieldValue) {
                requestedDataChange.rowList.push(row);
            }
            log('pushRowIntoRequestedDataChange()',requestedDataChange);
        };

        /**
         * Looping keys and when finding a match running a user defined function
         * @param rowIdSet row id's to loop
         * @param myFunction
         * @param passedDataModel
         */
        var loopData = function(rowIdSet, myFunction, passedDataModel){
            keyValueObjectService.loopData( rowIdSet, $scope.bulkEdit.sourceData.dataList, $scope.colKey, myFunction, passedDataModel );
        };

      var getSelectedRow = function() {
        var selected = ($scope.bulkEdit && $scope.bulkEdit.user && $scope.bulkEdit.user.selected) || {};
        var rowId = selected.rowId;
        if (!rowId) return null;

        var row = ($scope.bulkEdit.filteredDataList || []).find(function(r) {
          return r && r.id && r.id.value === rowId;
        });

        if (row) return row;

        return ($scope.bulkEdit.sourceData.dataList || []).find(function(r) {
          return r && r.id && r.id.value === rowId;
        }) || null;
      };

      var hasPairMismatch = function(leftValue, rightValue) {
        return (leftValue && !rightValue) || (!leftValue && rightValue);
      };

var recalculateActivityValidationState = function() {
    var rows = ($scope.bulkEdit && $scope.bulkEdit.sourceData && $scope.bulkEdit.sourceData.dataList) || [];
    var hasMismatch = false;

    for (var i = 0; i < rows.length && !hasMismatch; i++) {
        var row = rows[i];

        var a1 = ((row.activity1 && row.activity1.value) || '').toString().trim();
        var r1 = ((row.activity1Remuneration && row.activity1Remuneration.value) || '').toString().trim();
        if (hasPairMismatch(a1, r1)) { hasMismatch = true; break; }

        var a2 = ((row.activity2 && row.activity2.value) || '').toString().trim();
        var r2 = ((row.activity2Remuneration && row.activity2Remuneration.value) || '').toString().trim();
        if (hasPairMismatch(a2, r2)) { hasMismatch = true; break; }

        var a3 = ((row.activity3 && row.activity3.value) || '').toString().trim();
        var r3 = ((row.activity3Remuneration && row.activity3Remuneration.value) || '').toString().trim();
        if (hasPairMismatch(a3, r3)) { hasMismatch = true; break; }
    }

    // Persist on the model so it propagates back to parent on modal close
    $scope.bulkEdit.activityValidationState = hasMismatch ? 'ACT_VALIDATION_FAILED' : null;
    $scope.bulkEdit.activityValidationMessage = hasMismatch ? 'Activity and Remuneration fields must be filled together.' : '';

    // Also update $scope for immediate modal display
    $scope.activityFieldState = $scope.bulkEdit.activityValidationState;
    $scope.ajaxFailResponse = $scope.bulkEdit.activityValidationMessage;
};

        /**
         * Looper Function - Commits the response data to the source data and closes the modal
         * @param row
         * @param cell
         * @param responseData
         */
        var commitResponseData = function(row, cell, responseData){
          log('commitSourceData()',responseData);
          for (var rdIdx in responseData){
            log('rdIdx',rdIdx);
            log('responseData[rdIdx]',responseData[rdIdx]);
            if( row.id.value === responseData[rdIdx].id.value ) {
              angular.copy(responseData[rdIdx],row);
            }
          }
          recalculateActivityValidationState();
        };

      /**
         * Eventually done by server
         * @param number
         * @param precision
         * @returns {number}
         */
        var precisionRound = function(number, precision) {
            var factor = Math.pow(10, precision);
            return Math.round(number * factor) / factor;
        };

        /**
         * Eventually done by server
         * @param number
         * @param precision
         * @param percentage
         * @returns {number}
         */
        var percentageChange = function(number, precision, percentage) {
            log('percentageChange',[number, precision, percentage]);
            if(percentage==0){
                return number;
            } else {
                var multiplier = 1 + percentage/100;
                log('multiplier',multiplier);
                number = ( number * multiplier );
                log('number',number);
                return precisionRound(number, precision);
            }
        };

        var EMPTY_LIST = [undefined,'',null];
        var isEmpty = function(value){
            for(var idx in EMPTY_LIST){
                if(EMPTY_LIST[idx]===value){
                    return true;
                }
            }
            return false;
        };

        $scope.init = function(MODAL_DEBUG, useTestData, validateDataUrl, modifyTypeOptionList){
            $scope.MODAL_DEBUG = MODAL_DEBUG;
            $scope.useTestData = useTestData;
            $scope.validateDataUrl = validateDataUrl;
            $scope.modifyTypeOptionList = modifyTypeOptionList;
            $scope.bulkEdit.modifyType = {};
            $scope.removeData = false;
            setFieldLabel();
        };

      $scope.applyChangeToSourceData = function(isValidForm) {
        log('$scope.bulkEdit',$scope.bulkEdit);
        if(isValidForm) {
          applyChangeToSourceData();
          recalculateActivityValidationState();
        }
      };


      $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        var setFieldLabel = function(){
            $scope.fieldLabel = $scope.bulkEdit.sourceData.headerLabels[$scope.bulkEdit.user.selected.colKey].label;
        };

      $scope.setFlag = function(event) {
        $scope.removeData = true;
        event.preventDefault();
      };

      $scope.isActivityAndRemunerationRequired = function(colKey) {
        // Map activity fields to their corresponding remuneration fields
        const activityMap = {
          'activity1': 'activity1Remuneration',
          'activity2': 'activity2Remuneration',
          'activity3': 'activity3Remuneration'
        };

        const remunerationMap = {
          'activity1Remuneration': 'activity1',
          'activity2Remuneration': 'activity2',
          'activity3Remuneration': 'activity3'
        };

        // If editing an activity field, remuneration is required if activity has value
        if (activityMap[colKey]) {
          return $scope.bulkEdit.editableField && $scope.bulkEdit.editableField.trim() !== '';
        }

        // If editing a remuneration field, activity is required if remuneration has value
        if (remunerationMap[colKey]) {
          return $scope.bulkEdit.editableField && $scope.bulkEdit.editableField !== '';
        }

        return false;
      };

      $scope.validateActivityAndRemuneration = function(colKey) {
        var activityMap = {
          'activity1': 'activity1Remuneration',
          'activity2': 'activity2Remuneration',
          'activity3': 'activity3Remuneration'
        };
        var remunerationMap = {
          'activity1Remuneration': 'activity1',
          'activity2Remuneration': 'activity2',
          'activity3Remuneration': 'activity3'
        };

        var pairKey = activityMap[colKey] || remunerationMap[colKey];
        if (!pairKey) {
          recalculateActivityValidationState();
          return;
        }

        var row = getSelectedRow();
        if (!row) {
          recalculateActivityValidationState();
          return;
        }

        var currentValue = (($scope.bulkEdit.editableField == null ? '' : $scope.bulkEdit.editableField) + '').trim();
        var pairValue = ((row[pairKey] && row[pairKey].value != null ? row[pairKey].value : '') + '').trim();

        if (hasPairMismatch(currentValue, pairValue)) {
          var pairLabel = ($scope.bulkEdit.sourceData.headerLabels[pairKey] && $scope.bulkEdit.sourceData.headerLabels[pairKey].label) || pairKey;

          // Persist on model for parent propagation
          $scope.bulkEdit.activityValidationState = 'ACT_VALIDATION_FAILED';
          $scope.bulkEdit.activityValidationMessage = 'Enter ' + pairLabel;

          // Also update $scope for modal display
          $scope.activityFieldState = 'ACT_VALIDATION_FAILED';
          $scope.ajaxFailResponse = 'Enter ' + pairLabel;
          return;
        }

        recalculateActivityValidationState();
      };

      /**
       * Returns true if the cell should be highlighted as an error for activity/remuneration mismatch.
       * Only highlights the unfilled field in the pair.
       */
      $scope.isCellActivityRemunerationMismatch = function(row, colKey) {
        const activityMap = {
          'activity1': 'activity1Remuneration',
          'activity2': 'activity2Remuneration',
          'activity3': 'activity3Remuneration'
        };
        const remunerationMap = {
          'activity1Remuneration': 'activity1',
          'activity2Remuneration': 'activity2',
          'activity3Remuneration': 'activity3'
        };

        if ($scope.activityFieldState !== 'ACT_VALIDATION_FAILED') return false;

        var selected = $scope.bulkEdit.user.selected;
        if (!selected || !row || !row.id || row.id.value !== selected.rowId) return false;

        var editedKey = selected.colKey;
        var pairKey = activityMap[editedKey] || remunerationMap[editedKey];
        if (!pairKey) return false;

        // Only for edited field or its pair
        if (colKey !== editedKey && colKey !== pairKey) return false;

        var editedValue = (($scope.bulkEdit.editableField == null ? '' : $scope.bulkEdit.editableField) + '').trim();
        var pairValue = ((row[pairKey] && row[pairKey].value != null ? row[pairKey].value : '') + '').trim();

        // Highlight only the unfilled one
        if (colKey === editedKey) return !editedValue && !!pairValue;
        if (colKey === pairKey) return !!editedValue && !pairValue;

        return false;
      };
    };
    BulkEditFieldCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','params','ajaxCall','keyValueObjectService'];
    angular.module('app').controller('BulkEditFieldCtrl', BulkEditFieldCtrl);
}());
